:host {
  position: relative;
  display: block;
}

a {
  position: relative;
  width: 48px;
  height: 100%;
  font-family: $font-family-base;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  padding: 24px 0px 24px 0px;
  margin: 0px 4px 0px 4px;
  color: $navigation-main-icon-link-font-color;
  background-color: $navigation-main-icon-link-bg-color;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;

  eon-ui-icon {
    color: $navigation-main-icon-link-font-color;
  }

  // &::after {
  //   content: "";
  //   position: absolute;
  //   left: 0;
  //   bottom: -4px;
  //   width: 100%;
  //   height: 4px;
  //   background-color: $navigation-main-icon-link-border-color;
  // }

  &:hover {
    color: $navigation-main-icon-link-font-color-hover;
    background-color: $navigation-main-icon-link-bg-color-hover;

    // &::after {
    //   background-color: $navigation-main-icon-link-border-color-hover;
    // }

    eon-ui-icon {
      color: $navigation-main-icon-link-font-color-hover;
    }
  }

  &:focus {
    color: $navigation-main-icon-link-font-color-focus;
    background-color: $navigation-main-icon-link-bg-color-focus;
    outline: none;

    // &::after {
    //   background-color: $navigation-main-icon-link-border-color-focus;
    // }

    eon-ui-icon {
      color: $navigation-main-icon-link-font-color-focus;
    }
  }

  &.#{$prefix}current {
    color: $navigation-main-icon-link-font-color-current;
    background-color: $navigation-main-icon-link-bg-color-current;

    // &::after {
    //   background-color: $navigation-main-icon-link-border-color-current;
    // }

    eon-ui-icon {
      color: $navigation-main-icon-link-font-color-current;
    }

    &:hover {
      color: $navigation-main-icon-link-font-color-current-hover;
      background-color: $navigation-main-icon-link-bg-color-current-hover;

      // &::after {
      //   background-color: $navigation-main-icon-link-border-color-current-hover;
      // }

      eon-ui-icon {
        color: $navigation-main-icon-link-font-color-current-hover;
      }
    }

    &:focus {
      color: $navigation-main-icon-link-font-color-current-focus;
      background-color: $navigation-main-icon-link-bg-color-current-focus;
      outline: none;

      // &::after {
      //   background-color: $navigation-main-icon-link-border-color-current-focus;
      // }

      eon-ui-icon {
        color: $navigation-main-icon-link-font-color-current-focus;
      }
    }
  }

  &.#{$prefix}active {
    color: $navigation-main-icon-link-font-color-active;
    background-color: $navigation-main-icon-link-bg-color-active;

    // &::after {
    //   background-color: $navigation-main-icon-link-border-color-active;
    // }

    eon-ui-icon {
      color: $navigation-main-icon-link-font-color-active;
    }

    &:hover {
      color: $navigation-main-icon-link-font-color-active-hover;
      background-color: $navigation-main-icon-link-bg-color-active-hover;

      // &::after {
      //   background-color: $navigation-main-icon-link-border-color-active-hover;
      // }

      eon-ui-icon {
        color: $navigation-main-icon-link-font-color-active-hover;
      }
    }

    &:focus {
      color: $navigation-main-icon-link-font-color-active-focus;
      background-color: $navigation-main-icon-link-bg-color-active-focus;
      outline: none;

      // &::after {
      //   background-color: $navigation-main-icon-link-border-color-active-focus;
      // }

      eon-ui-icon {
        color: $navigation-main-icon-link-font-color-active-focus;
      }
    }
  }

  .#{$prefix}icon-wrapper {
    + .#{$prefix}text-wrapper {
      margin-left: 4px;
    }
  }

  &.#{$prefix}mobile {
    color: $navigation-mobile-link-font-color !important;
    background-color: transparent !important;

    eon-ui-icon {
      color: $navigation-mobile-link-font-color !important;
    }
  }
}
